export default __webpack_public_path__ + "static/grow-7b801f2319b98e3fd112b2cb9c0fdaf8.jpg";